import { type FC, memo, type ReactNode } from 'react';
import { BlockLink } from 'BlockLink';
import { BottomAlignedWithButton } from '../BottomAlignedWithButton';
import { StartDiscussionButton } from '../StartDiscussionButton/StartDiscussionButton';
import { type SupportedColors } from '../../TutorBotVoiceAgent.types';

type Props = {
    onStartDiscussionClick: () => void;
    IntroComponent: ReactNode;
    abortFromRoom: () => void;
    abortText: string;
    color: SupportedColors | undefined;
    startDiscussionText: string | undefined | null;
};

const StartScreenComponent: FC<Props> = ({
    onStartDiscussionClick,
    IntroComponent,
    abortFromRoom,
    abortText,
    color,
    startDiscussionText,
}) => (
    <BottomAlignedWithButton
        Main={IntroComponent}
        Button={<StartDiscussionButton onPress={onStartDiscussionClick} color={color} content={startDiscussionText} />}
        Bottom={
            <BlockLink onPress={abortFromRoom} color="slate-grey">
                {abortText}
            </BlockLink>
        }
    />
);

export const StartScreen = memo(StartScreenComponent) as typeof StartScreenComponent;
